import bee from "./Bee";
export default {
    name: "Notifications",
    /*
        var query = {
            user_id: 0,
            page_size: 10
            page: 1,
        }
    */
    /* eslint-disable no-unused-vars */
    get_notifications(query, success, fail) {
        bee.get({
            notifications: {
                _desc: ["id"],
                _pg: query.page_size + "." + query.page,
                _w: [
                    ["user_id","e",query.user_id]
                ]
            }
        })
            .then(res => {
                //console.log("Received alerts ", res);
                if (success) {
                    success(res.notifications);
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    update_status(query, success, fail) {

        bee.update({
            notification: {
                is_read: 1,
                _date_date_read: "",
                _now_date_read_timestamp: "",
                _w: [
                    ["id","e",query.id]
                ]
            }
        })
            .then(res => {
                //console.log("Received alerts ", res);
                if (success) {
                    success({
                        response: res.notification,
                        query: query
                    });
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    get_notifications_count(query, success, fail) {
        bee.get({
            notifications: {
                _a: " _count ",
                _w: [
                    ["user_id","e",query.user_id]
                ]
            }
        })
            .then(res => {
                //console.log("Received alerts ", res);
                if (success) {
                    success(res.notifications[0].count);
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
}